import { Box } from '@mui/material';
import { useCaseFieldData } from '../../hooks/useCaseField';
import type { FieldMode } from '../../hooks/useCaseField';
import { CaseTextField, CaseCheckboxField } from '../fields';
import type { MedNecCaseView, GuarantorInfo } from '../../../../services/MedNecService/types/medNecTypes';

interface GuarantorSectionProps {
  mode: FieldMode;
}

// Helper: read a guarantor text field
const g = (field: keyof GuarantorInfo) => (d: MedNecCaseView) => (d.guarantor?.[field] as string) ?? '';

// Helper: produce an update that merges a single guarantor field
const gUp = (field: keyof GuarantorInfo) => (v: string, d: MedNecCaseView): Partial<MedNecCaseView> => ({
  guarantor: { ...d.guarantor!, [field]: v },
});

const GuarantorSection: React.FC<GuarantorSectionProps> = ({ mode }) => {
  const data = useCaseFieldData(mode);
  const guarantor = data.guarantor;

  if (!guarantor) return null;

  return (
    <Box sx={{ mb: 2.5 }}>
      <Box sx={{ mb: 1.5 }}>
        <CaseCheckboxField mode={mode} label="Same as Patient"
          getValue={d => d.guarantor?.sameAsPatient ?? false}
          getUpdate={(v, d) => ({ guarantor: { ...d.guarantor!, sameAsPatient: v } })} />
      </Box>
      {!guarantor.sameAsPatient && (
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 1.5 }}>
          <CaseTextField mode={mode} label="Name" getValue={g('name')} getUpdate={gUp('name')} />
          <CaseTextField mode={mode} label="Relationship" getValue={g('relationship')} getUpdate={gUp('relationship')} />
          <CaseTextField mode={mode} label="Date of Birth" type="date" shrinkLabel
            getValue={d => { const v = g('dateOfBirth')(d); return v.includes('T') ? v.split('T')[0] : v; }}
            getUpdate={gUp('dateOfBirth')} />
        </Box>
      )}
    </Box>
  );
};

export default GuarantorSection;
